/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationLanguage,
    CommunicationLanguageFromJSON,
    CommunicationLanguageFromJSONTyped,
    CommunicationLanguageToJSON,
    CommunicationStatus,
    CommunicationStatusFromJSON,
    CommunicationStatusFromJSONTyped,
    CommunicationStatusToJSON,
    ObjectTypeEnum,
    ObjectTypeEnumFromJSON,
    ObjectTypeEnumFromJSONTyped,
    ObjectTypeEnumToJSON,
    ResponseInfo,
    ResponseInfoFromJSON,
    ResponseInfoFromJSONTyped,
    ResponseInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PutCommunicationItem
 */
export interface PutCommunicationItem {
    /**
     * 
     * @type {string}
     * @memberof PutCommunicationItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PutCommunicationItem
     */
    parentCommunicationId?: string | null;
    /**
     * 
     * @type {ObjectTypeEnum}
     * @memberof PutCommunicationItem
     */
    objectType?: ObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutCommunicationItem
     */
    objectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PutCommunicationItem
     */
    communication?: string | null;
    /**
     * 
     * @type {CommunicationLanguage}
     * @memberof PutCommunicationItem
     */
    language?: CommunicationLanguage;
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PutCommunicationItem
     */
    responseInfo?: ResponseInfo;
    /**
     * 
     * @type {CommunicationStatus}
     * @memberof PutCommunicationItem
     */
    communicationStatus?: CommunicationStatus;
}

export function PutCommunicationItemFromJSON(json: any): PutCommunicationItem {
    return PutCommunicationItemFromJSONTyped(json, false);
}

export function PutCommunicationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutCommunicationItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'parentCommunicationId': !exists(json, 'parentCommunicationId') ? undefined : json['parentCommunicationId'],
        'objectType': !exists(json, 'objectType') ? undefined : ObjectTypeEnumFromJSON(json['objectType']),
        'objectId': !exists(json, 'objectId') ? undefined : json['objectId'],
        'communication': !exists(json, 'communication') ? undefined : json['communication'],
        'language': !exists(json, 'language') ? undefined : CommunicationLanguageFromJSON(json['language']),
        'responseInfo': !exists(json, 'responseInfo') ? undefined : ResponseInfoFromJSON(json['responseInfo']),
        'communicationStatus': !exists(json, 'communicationStatus') ? undefined : CommunicationStatusFromJSON(json['communicationStatus']),
    };
}

export function PutCommunicationItemToJSON(value?: PutCommunicationItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parentCommunicationId': value.parentCommunicationId,
        'objectType': ObjectTypeEnumToJSON(value.objectType),
        'objectId': value.objectId,
        'communication': value.communication,
        'language': CommunicationLanguageToJSON(value.language),
        'responseInfo': ResponseInfoToJSON(value.responseInfo),
        'communicationStatus': CommunicationStatusToJSON(value.communicationStatus),
    };
}


